import * as Styled from "./styled";
import Page from "@/components/layout/Page";
import useCompany from "@/contexts/CompanyContext";
import DashboardCustomers from "./DashboardCustomers";
import DashboardProspecting from "./DashboardProspecting";

const Dashboard = () => {
  const company = useCompany();

  const isCustomer =
    company.companyStatus === "live" ||
    company.companyStatus === "onboarding" ||
    company.companyStatus === "integration";

  return (
    <Page title="Dashboard" isDashboard >
      <Styled.Dashboard data-testid="dashboard">
        {isCustomer ? (
          <DashboardCustomers />
        ) : (
          <DashboardProspecting />
        )}
      </Styled.Dashboard>
    </Page>
  );
};

export default Dashboard;
